import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[tusangaireNumbersOnlyStartingOne]'
})
export class NumberOnlyStartingFromOneDirective {
  constructor(private _el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: any): void {
    const initalValue = this._el.nativeElement.value;

    // Allow numbers starting with 1-9 and including 0 anywhere except the first position
    this._el.nativeElement.value = initalValue.replace(/[^0-9]/g, '').replace(/^0/, '');

    // If the input value changed, stop propagation
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
